const tokenIssueUrl = '/token/issue';
const voteOptionSaveUrl = '/telegram/save';
const fileUploadUrl = '/file/upload';
const UPDATE_VOTE_RECLAIM = '/networkdao/vote/reclaim';

const tmrwNeedAuthList = [voteOptionSaveUrl, fileUploadUrl, UPDATE_VOTE_RECLAIM];
export { tokenIssueUrl, voteOptionSaveUrl, tmrwNeedAuthList, fileUploadUrl };
